import { Component, OnInit, ViewChild, ElementRef, Input, Output, TemplateRef, Pipe, PipeTransform } from '@angular/core';
import { MdSnackBar } from '@angular/material';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Subject';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Store } from '@ngrx/store';
import * as fromCommonStore from '../../../store';
import * as fromRootStore from '../../../reducers';

import { PurchaseInvoiceService, CommonService, SubscribeService, BranchService } from '../../../services/index';
import { PurchaseInvoiceModel } from '../../../model/index';

@Component({
    selector: 'addeditPurchaseInvoice-tab',
    templateUrl: './addEditPurchaseInvoice.component.html',
})
export class AddEditPurchaseInvoiceComponent implements OnInit {
    private searchTerms = new Subject<string>();
    private searchTermsEmp = new Subject<string>();

    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;
    _params: any[] = [];
    @Input() set params(val: any[]) {
        this._params = val;
        this.setPageData();
    }

    public mode: string;
    public list: any[] = [];
    //public salesbilltypesdata: any[] = [];

    isLoadMask: Promise<any>;
    //salesbilltypesData: SalesBillentryModel[];
    isLoading: boolean = false;
    minDate: any;

    @Input() purchasegriddata: any = {};
    @Input() purchaseInvoice: PurchaseInvoiceModel[] = [];
    partyCtrl: FormControl;
    toGiveCtrl: FormControl;
    branchCtrl: FormControl;
    hvUserCtrl: FormControl;
    typeCtrl: FormControl;
    purchasetypeCtrl: FormControl;
    taxTypeCtrl: FormControl;
    modelCtrl: FormControl;
    returnNoCtrl: FormControl;
    returnSerialNoCtrl: FormControl;
    filteredParty: Observable<any[]>;
    filteredBranch: Observable<any[]>;
    filteredHvUser: Observable<any[]>;
    filteredModel: Observable<any[]>;
    filteredReturnNo: Observable<any[]>;
    filteredSerialReturnNo: Observable<any[]>;
    filteredBrandModel: Observable<any[]>;
    filteredBrand: Observable<any[]>;
    filteredFamily: Observable<any[]>;
    filteredSeries: Observable<any[]>;
    filteredPower: Observable<any[]>;
    filteredPerformance: Observable<any[]>;
    filteredBattery: Observable<any[]>;
    brandModelList$: any[] = [];
    brandModelCtrl: FormControl;
    brandList$: any[] = [];
    brandCtrl: FormControl;
    familyList$: any[] = [];
    seriesList$: any[] = [];
    powerList$: any[] = [];
    performanceList$: any[] = [];
    batteryList$: any[] = [];
    familyCtrl: FormControl;
    seriesCtrl: FormControl;
    powerCtrl: FormControl;
    performanceCtrl: FormControl;
    batteryCtrl: FormControl;
    PartyList = [];
    toGiveTypeList = ['Branch', 'HV Team'];
    taxTypeList = ['SGST and CGST', 'IGST'];
    branchList = [];
    hvUserList = [];
    ModelList = [];
    returnList = [];
    returnSerialList = [];
    typeList = [];
    purchasetypeList = [];
    actModelList = [];
    monthList = [];
    yearList = [];
    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;

    reorderable: boolean = true;
    page = {
        limit: 100,
        count: 0,
        offset: 0,
        orderBy: 'purchase_id',
        orderDir: 'asc'
    };
    columns = [];
    purchaseInvoiceDetails = [];

    constructor(public store: Store<fromRootStore.State>, private modalService: BsModalService,
        private purchaseInvoiceService: PurchaseInvoiceService,
        private commonService: CommonService,
        private branchService: BranchService,
        public snackBar: MdSnackBar,
        public toasterService: ToasterService,
        public subscribeService: SubscribeService) {

        //this.halistCtrl = new FormControl();
        //FOR AUTO COMPLETE VALIDATION --- BRAND MODEL
        function hasValidParty(input: FormControl) {
            let partyID = input.value, retVal = null;
            if (partyID == "") {
                retVal = { inValidParty: true };
            }
            if (partyID && typeof partyID === 'string') {
                retVal = { inValidParty: true };
            }
            return retVal;
        }
        this.partyCtrl = new FormControl('', [
            Validators.required,
            hasValidParty.bind(this)
        ]);
        this.filteredParty = this.partyCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterParty(name) : this.PartyList.slice());

        //FOR AUTO COMPLETE VALIDATION --- TO GIVE TYPE
        function hasValidToGiveType(input: FormControl) {
            if (this.toGiveTypeList.indexOf(input.value) >= 0)
                return null;
            else
                return { inValidToGiveType: true };
        }
        this.toGiveCtrl = new FormControl('', [
            Validators.required,
            hasValidToGiveType.bind(this)
        ]);

        //FOR AUTO COMPLETE VALIDATION --- TAX TYPE
        function hasValidTaxType(input: FormControl) {
            if (this.taxTypeList.indexOf(input.value) >= 0)
                return null;
            else
                return { inValidTaxType: true };
        }
        this.taxTypeCtrl = new FormControl('SGST and CGST', [
            Validators.required,
            hasValidTaxType.bind(this)
        ]);

        //FOR AUTO COMPLETE VALIDATION --- HV USER
        function hasValidHvUser(input: FormControl) {
            let userID = input.value, retVal = null;
            if (userID == "") {
                retVal = { inValidHvUser: true };
            }
            if (userID && typeof userID === 'string') {
                retVal = { inValidHvUser: true };
            }
            return retVal;
        }
        this.hvUserCtrl = new FormControl('', [
            Validators.required,
            hasValidHvUser.bind(this)
        ]);
        this.filteredHvUser = this.hvUserCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterHvUser(name) : this.hvUserList ? this.hvUserList.slice() : []);

        //FOR AUTO COMPLETE VALIDATION --- BRANCH
        function hasValidBranch(input: FormControl) {
            let branchID = input.value, retVal = null;
            if (branchID == "") {
                retVal = { inValidBranch: true };
            }
            if (branchID && typeof branchID === 'string') {
                retVal = { inValidBranch: true };
            }
            return retVal;
        }
        this.branchCtrl = new FormControl('', [
            Validators.required,
            hasValidBranch.bind(this)
        ]);
        this.filteredBranch = this.branchCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterBranch(name) : this.branchList.slice());

        //FOR AUTO COMPLETE VALIDATION --- MODEL COMBO
        function hasValidModel(input: FormControl) {
            let brandID = input.value, retVal = null;
            if (brandID == "") {
                retVal = { inValidModel: true };
            }
            if (brandID && typeof brandID === 'string') {
                retVal = { inValidModel: true };
            }
            return retVal;
        }
        this.modelCtrl = new FormControl('', [
            Validators.required,
            hasValidModel.bind(this)
        ]);
        this.filteredModel = this.modelCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterModel(name) : this.ModelList.slice());

        this.returnNoCtrl = new FormControl('');
        this.filteredReturnNo = this.returnNoCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterReturnList(name) : this.returnList.slice());

        this.returnSerialNoCtrl = new FormControl('');
        this.filteredSerialReturnNo = this.returnSerialNoCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterReturnSerialList(name) : this.returnSerialList.slice());

        //FOR AUTO COMPLETE VALIDATION --- BRAND MODEL
        function hasValidType(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "HA Model" && ledgerID != "Spare") {
                retVal = { inValidType: true };
            }

            return retVal;
        }
        this.typeCtrl = new FormControl('', [
            Validators.required,
            hasValidType.bind(this)
        ]);

        //FOR AUTO COMPLETE VALIDATION --- PURCHASE TYPE
        function hasValidPurType(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Normal" && ledgerID != "Service") {
                retVal = { inValidType: true };
            }

            return retVal;
        }
        this.purchasetypeCtrl = new FormControl('', [
            Validators.required,
            hasValidPurType.bind(this)
        ]);

        //FOR AUTO COMPLETE VALIDATION --- BRAND MODEL
        function hasValidBrandModel(input: FormControl) {
            let brandModelID = input.value, retVal = null;
            if (brandModelID == "") {
                retVal = { inValidBrandModel: true };
            }
            if (brandModelID && typeof brandModelID === 'string') {
                retVal = { inValidBrandModel: true };
            }
            return retVal;
        }
        this.brandModelCtrl = new FormControl('', [
            Validators.required,
            hasValidBrandModel.bind(this)
        ]);
        this.filteredBrandModel = this.brandModelCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterBrandModel(name) : this.brandModelList$.slice());
        //FOR AUTO COMPLETE VALIDATION --- BRAND COMBO
        function hasValidBrand(input: FormControl) {
            let brandID = input.value, retVal = null;
            if (brandID == "") {
                retVal = { inValidBrand: true };
            }
            if (brandID && typeof brandID === 'string') {
                retVal = { inValidBrand: true };
            }
            return retVal;
        }
        this.brandCtrl = new FormControl('', [
            Validators.required,
            hasValidBrand.bind(this)
        ]);
        this.filteredBrand = this.brandCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterBrand(name) : this.brandList$.slice());

        //FOR AUTO COMPLETE VALIDATION --- FAMILY COMBO
        function hasValidFamily(input: FormControl) {
            let familyID = input.value, retVal = null;
            if (familyID == "") {
                retVal = { inValidFamily: true };
            }
            if (familyID && typeof familyID === 'string') {
                retVal = { inValidFamily: true };
            }
            return retVal;
        }
        this.familyCtrl = new FormControl('', [
            Validators.required,
            hasValidFamily.bind(this)
        ]);
        this.filteredFamily = this.familyCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterFamily(name) : this.familyList$.slice());
        
        //Series
        function hasValidSeries(input: FormControl) {
            let seriesID = input.value, retVal = null;
            if (seriesID && typeof seriesID === 'string') {
                retVal = { inValidSeries: true };
            }
            return retVal;
        }
        this.seriesCtrl = new FormControl('', hasValidSeries.bind(this));

        this.filteredSeries = this.seriesCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterSeries(name) : this.seriesList$.slice());

        //Performance
        function hasValidPerformance(input: FormControl) {
            let performanceID = input.value, retVal = null;
            if (performanceID && typeof performanceID === 'string') {
                retVal = { inValidPerformance: true };
            }
            return retVal;
        }
        this.performanceCtrl = new FormControl('', hasValidPerformance.bind(this));

        this.filteredPerformance = this.performanceCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterPerformance(name) : this.performanceList$.slice());

        //Power
        function hasValidPower(input: FormControl) {
            let powerID = input.value, retVal = null;
            if (powerID && typeof powerID === 'string') {
                retVal = { inValidPower: true };
            }
            return retVal;
        }
        this.powerCtrl = new FormControl('', hasValidPower.bind(this));
        this.filteredPower = this.powerCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterPower(name) : this.powerList$.slice());

        //Battery
        function hasValidBattery(input: FormControl) {
            let batteryID = input.value, retVal = null;
            if (batteryID && typeof batteryID === 'string') {
                retVal = { inValidBattery: true };
            }
            return retVal;
        }
        this.batteryCtrl = new FormControl('', hasValidBattery.bind(this));
        this.filteredBattery = this.batteryCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterBattery(name) : this.batteryList$.slice());

    }

    ngOnInit(): void {
        let that = this;

        // Initialize purchasegriddata with default tax values
        if (!this.purchasegriddata || typeof this.purchasegriddata !== 'object') {
            this.purchasegriddata = {};
        }
        if (!this.purchasegriddata.tax_type) {
            this.purchasegriddata.tax_type = 'SGST and CGST';
            this.purchasegriddata.tax = 0;
            this.purchasegriddata.tax_amount = 0;
            this.purchasegriddata.sgst_rate = 0;
            this.purchasegriddata.cgst_rate = 0;
            this.purchasegriddata.igst_rate = 0;
        }

        this.columns = [
            { name: 'SNo', prop: 'sno', width: 50, minWidth: 50, maxWidth: 50, sortable: false, cellTemplate: this.snoTemplate },
            // { name: 'Return No', prop: 'return_no', width: 110, minWidth: 110, maxWidth: 110, sortable: false, cellClass: 'cell-left' },
            // { name: 'Return Serial', prop: 'return_serial_no', width: 110, minWidth: 110, maxWidth: 110, sortable: false, cellClass: 'cell-left' },
            { name: 'Type', prop: 'stock_type', width: 110, minWidth: 110, maxWidth: 110, sortable: false, cellClass: 'cell-left' },
            { name: 'Model', prop: 'model_name', width: 220, minWidth: 220, maxWidth: 220, sortable: false, cellClass: 'cell-left' },
            { name: 'Serial No', prop: 'serial_no', width: 140, minWidth: 140, maxWidth: 140, sortable: false, cellClass: 'cell-left' },
            { name: 'Brand', prop: 'name', width: 120, minWidth: 120, maxWidth: 120, sortable: false, cellClass: 'cell-left' },
            { name: 'Brand Model', prop: 'disp_name', width: 150, minWidth: 150, maxWidth: 150, sortable: false, cellClass: 'cell-left' },
            { name: 'Family', prop: 'family_name', width: 130, minWidth: 130, maxWidth: 130, sortable: false, cellClass: 'cell-left' },
            { name: 'Series', prop: 'series_name', width: 110, minWidth: 110, maxWidth: 110, sortable: false, cellClass: 'cell-left' },
            { name: 'Month', prop: 'month', width: 110, minWidth: 110, maxWidth: 110, sortable: false, cellClass: 'cell-left' },
            { name: 'Year', prop: 'year', width: 100, minWidth: 100, maxWidth: 100, sortable: false, cellClass: 'cell-right' },
            { name: 'Performance', prop: 'performance_name', width: 130, minWidth: 130, maxWidth: 130, sortable: false, cellClass: 'cell-left' },
            { name: 'Power', prop: 'power_name', width: 110, minWidth: 110, maxWidth: 110, sortable: false, cellClass: 'cell-left' },
            { name: 'Battery/Rechargeable', prop: 'battery_name', width: 180, minWidth: 180, maxWidth: 180, sortable: false, cellClass: 'cell-left' },
            { name: 'Color', prop: 'color_name', width: 130, minWidth: 130, maxWidth: 130, sortable: false, cellClass: 'cell-left' },
            { name: 'Tele Audiology', prop: 'tele_audiology', width: 140, minWidth: 140, maxWidth: 140, sortable: false, cellClass: 'cell-left' },
            { name: 'Quantity', prop: 'act_qty', width: 100, minWidth: 100, maxWidth: 100, sortable: false, cellClass: 'cell-right' },
            { name: 'MRP', prop: 'mrp_value', width: 100, minWidth: 100, maxWidth: 100, sortable: false, cellClass: 'cell-right' },
            { name: 'Tax Type', prop: 'tax_type', width: 140, minWidth: 140, maxWidth: 140, sortable: false, cellClass: 'cell-left' },
            { name: 'SGST %', prop: 'sgst_rate', width: 120, minWidth: 120, maxWidth: 120, sortable: false, cellClass: 'cell-right' },
            { name: 'CGST %', prop: 'cgst_rate', width: 120, minWidth: 120, maxWidth: 120, sortable: false, cellClass: 'cell-right' },
            { name: 'IGST %', prop: 'igst_rate', width: 120, minWidth: 120, maxWidth: 120, sortable: false, cellClass: 'cell-right' },
            { name: 'Tax %', prop: 'tax', width: 100, minWidth: 100, maxWidth: 100, sortable: false, cellClass: 'cell-right' },
            { name: 'Tax Amount', prop: 'tax_amount', width: 120, minWidth: 120, maxWidth: 120, sortable: false, cellClass: 'cell-right' },
            { name: 'Discount', prop: 'discount', width: 100, minWidth: 100, maxWidth: 100, sortable: false, cellClass: 'cell-right' },
            { name: 'Amount', prop: 'total_amount', width: 100, minWidth: 100, maxWidth: 100, sortable: false, cellClass: 'cell-right' },
            { name: 'Action', prop: 'sno', width: 100, minWidth: 100, maxWidth: 100, sortable: false, cellClass: 'cell-center', cellTemplate: this.editDeleteTemplate }
        ];


        //TO LOAD PARTY LIST
        this.loadPartyList();
        //TO LOAD BRANCH LIST
        this.loadBranchList();
        //TO LOAD HV USER LIST
        this.loadHvUserList();
        this.typeList = ['HA Model', 'Spare'];
        this.purchasetypeList = ['Normal', 'Service'];
        this.monthList = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        this.yearList = Array.from({ length: 31 }, (_, i) => (2020 + i).toString());

        if (this._params['mode'] == 'Add') {
            this.loadAutoNumber();
            this.minDate = new Date(new Date().getFullYear(),
                new Date().getMonth(),
                new Date().getDate());
            this.purchaseInvoice['date'] = new Date();
        }

        this.store.select(fromCommonStore.getAllBrandModel).subscribe((res: any) => {
            if (_.isEmpty(res)) {
                //this.store.dispatch(new commonActions.LoadAllBrandModel());
                //this.brandModelList$ = res;
                return;
            }
            this.brandModelList$ = res;
        });
        this.store.select(fromCommonStore.getAllBrand).subscribe((res: any) => {
            if (_.isEmpty(res)) {
                //this.store.dispatch(new commonActions.LoadAllBrandModel());
                //this.brandList$ = res;
                return;
            }
            this.brandList$ = res;
        });

    }

    loadFamilyList() {
        let that = this;
        this.commonService
            .getFamilyList()
            .then(function(res: any) {
                // that.familyList$ = res.data;
                const familydata = res.data.filter(item => item.brand_id === that.purchasegriddata['brand_id']);
                that.familyList$ = familydata;
                that.familyCtrl.setValue(that.purchasegriddata['family_id']);
            });
    }
    onChangePageSize(limit) {
        this.page.limit = limit;
        // this.getPurchaseInvoiceList();
    }

        pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
            this.page.offset = pageInfo.offset;
            this.getPurchaseInvoiceDetailList();
        } 
    loadPartyList() {
        let that = this;
        this.commonService
            .getPartyList()
            .then(function (res: any) {
                if (res.success) {
                    that.PartyList = res.data;
                    that.partyCtrl.setValue(that.purchaseInvoice['party_id']);
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: 'Oops....Something Went Wrong'
                    };
                    that.toasterService.pop(toast);
                }
            });
    }

    loadBranchList() {
        let that = this;
        this.store.select(fromCommonStore.getAllBranch).subscribe((res: any) => {
            if (_.isEmpty(res.data)) {
                return;
            }
            this.store.select(fromCommonStore.getAuth).subscribe((auth: any) => {
                if (auth['islogin']) {
                    let branches = _.filter(res.data, function (obj) { return obj['is_crm_branch'] == 'Yes' && obj['is_hv_center'] == 'false'});
                    that.branchList = _.filter(branches, function (obj) { return obj['branch_id'] && obj['store_branch'] == 'Yes'});
                    that.branchCtrl.setValue(that.purchaseInvoice['branch_id']);
                }
            });
        });
    }

    loadHvUserList() {
        let that = this;
        let data = {
            fol_id: 1
        };
        this.commonService.getHVUserList(data).then(function (res: any) {
            if (res && res.data && res.data.length) {
                that.hvUserList = res.data;
                that.hvUserCtrl.setValue(that.purchaseInvoice['hv_user_id']);
            }
        });
    }

    loadStockModelList() {
        let that = this,
            data = {
                type: 'All',
                comp_stock: 'No'
            };
        this.commonService
            .getStockModelList(data)
            .then(function (res: any) {
                if (res.success) {

                    if(that.purchasegriddata['stock_type']=='Spare'){
                        that.actModelList = res.data;
                        that.onSelectedType(that.purchasegriddata['stock_type']);
                    } else if(that.purchasegriddata['stock_type']=='HA Model'){
                        // if(that.purchasegriddata['brand_model_id']==undefined || that.purchasegriddata['brand_model_id']== ''){
                        //     that.purchasegriddata['brand_model_id'] = 0;
                        // }
                        // if(that.purchasegriddata['series_id']==undefined || that.purchasegriddata['series_id']== ''){
                        //     that.purchasegriddata['series_id'] = 0;
                        // }
                        // if(that.purchasegriddata['performance_id']==undefined || that.purchasegriddata['performance_id']== ''){
                        //     that.purchasegriddata['performance_id'] = 0;
                        // }
                        // if(that.purchasegriddata['power_id']==undefined || that.purchasegriddata['power_id']== ''){
                        //     that.purchasegriddata['power_id'] = 0;
                        // }
    
                        // const modeldata = res.data.filter(item => (item.brand_id === that.purchasegriddata['brand_id'] && item.brand_model_id === that.purchasegriddata['brand_model_id'] && item.family_id === that.purchasegriddata['family_id'] && item.series_id === that.purchasegriddata['series_id'] && item.performance_id === that.purchasegriddata['performance_id'] && item.power_id === that.purchasegriddata['power_id'] && item.battery_id === that.purchasegriddata['battery_id']));
                        // that.actModelList = modeldata;
                        that.actModelList = res.data;
                        that.onSelectedType(that.purchasegriddata['stock_type']); 
                    }                  
                    // that.actModelList = res.data;
                    //that.ModelList = res.data;
                    //that.modelCtrl.setValue(that.purchaseInvoice['model_id']);
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: 'Oops....Something Went Wrong'
                    };
                    that.toasterService.pop(toast);
                }
            });
    }

    //BRAND MODEL
    filterBrandModel(name: string) {
        name = _.escapeRegExp(name);
        return this.brandModelList$.filter(item => (new RegExp(name, 'gi').test(item.disp_name)));
    }
    displayFn(modelID: number) {
        if (modelID && this.brandModelList$.length > 0) {
            let fitem = _.find(this.brandModelList$, { 'model_id': modelID });
            this.purchasegriddata['disp_name'] = fitem['disp_name'];
            return fitem['disp_name'];
        }
        return '';
    }
    //BRAND
    filterBrand(name: string) {
        name = _.escapeRegExp(name);
        return this.brandList$.filter(item => (new RegExp(name, 'gi').test(item.name)));
    }
    displayBrandFn(brandID: number) {
        if (brandID && this.brandList$.length > 0) {
            let fitem = _.find(this.brandList$, { 'brand_id': brandID });
            this.purchasegriddata['name'] = fitem['name'];
            return fitem['name'];
        }
        return '';
    }
    //FAMILY
    filterFamily(name: string) {
        name = _.escapeRegExp(name);
        return this.familyList$.filter(item => (new RegExp(name, 'gi').test(item.family_name)));
    }
    displayFamilyFn(familyID: number) {
        if (familyID && this.familyList$.length > 0) {
            let fitem = _.find(this.familyList$, { 'family_id': familyID });
            this.purchasegriddata['family_name'] = fitem['family_name'];
            return fitem['family_name'];
        }
        return '';
    }

    onChangeFamily(){
        this.loadFamilyList();
        this.loadAllList();
    }

    //Series
    filterSeries(name: string) {
        name = _.escapeRegExp(name);
        return this.seriesList$.filter(item => (new RegExp(name, 'gi').test(item.series_name)));
    }
    displaySeriesFn(seriesID: number) {
        if (seriesID && this.seriesList$.length > 0) {
            let seriesitem = _.find(this.seriesList$, { 'series_id': seriesID });
            this.purchasegriddata['series_name'] = seriesitem['series_name'];
            return seriesitem['series_name'];
        }
        return '';
    }

     //Performance
     filterPerformance(name: string) {
        name = _.escapeRegExp(name);
        return this.performanceList$.filter(item => (new RegExp(name, 'gi').test(item.performance_name)));
    }
    displayPerformanceFn(performanceID: number) {
        if (performanceID && this.performanceList$.length > 0) {
            let performanceitem = _.find(this.performanceList$, { 'performance_id': performanceID });
            this.purchasegriddata['performance_name'] = performanceitem['performance_name'];
            return performanceitem['performance_name'];
        }
        return '';
    }

    //Power
    filterPower(name: string) {
        name = _.escapeRegExp(name);
        return this.powerList$.filter(item => (new RegExp(name, 'gi').test(item.power_name)));
    }
    displayPowerFn(powerID: number) {
        if (powerID && this.powerList$.length > 0) {
            let poweritem = _.find(this.powerList$, { 'power_id': powerID });
            this.purchasegriddata['power_name'] = poweritem['power_name'];
            return poweritem['power_name'];
        }
        return '';
    }

    //Battery
    filterBattery(name: string) {
        name = _.escapeRegExp(name);
        return this.batteryList$.filter(item => (new RegExp(name, 'gi').test(item.battery_name)));
    }
    displayBatteryFn(batteryID: number) {
        if (batteryID && this.batteryList$.length > 0) {
            let batteryitem = _.find(this.batteryList$, { 'battery_id': batteryID });
            this.purchasegriddata['battery_name'] = batteryitem['battery_name'];
            return batteryitem['battery_name'];
        }
        return '';
    }

    loadAllList() {
        let that = this;
        //to get series list
        this.commonService
            .getAllList()
            .then(function(res: any) {
                const seriesdata = res.data.filter(item => item.brand_id === that.purchasegriddata['brand_id']);
                that.seriesList$ = seriesdata;
                that.seriesCtrl.setValue(that.purchasegriddata['series_id']);

                const powerdata = res.powerdata.filter(item => item.brand_id === that.purchasegriddata['brand_id']);
                that.powerList$ = powerdata;
                that.powerCtrl.setValue(that.purchasegriddata['power_id']);

                const performancedata = res.performancedata.filter(item => item.brand_id === that.purchasegriddata['brand_id']);
                that.performanceList$ = performancedata;
                that.performanceCtrl.setValue(that.purchasegriddata['performance_id']);

                // const batterydata = res.batterydata.filter(item => item.brand_id === that.purchasegriddata['brand_id']);
                that.batteryList$ = res.batterydata;
                that.batteryCtrl.setValue(that.purchasegriddata['battery_id']);

            });  
    }

    onSelectedType(typeName) {
        this.ModelList = [];
        this.ModelList = _.filter(this.actModelList, { 'from_page': typeName });
        this.modelCtrl.setValue(this.purchaseInvoice['model_id']);
    }
    filterParty(name: string) {
        name = _.escapeRegExp(name);
        return this.PartyList.filter(item => (new RegExp(name, 'gi').test(item.party_name)));
    }

    displayPartyFn(partyID: number) {
        if (partyID && this.PartyList.length > 0) {
            let fitem = _.find(this.PartyList, { 'party_id': partyID });
            this.onSelectPartyName(fitem['party_id']);
            return fitem['party_name'];
        }
        return '';
    }

    filterBranch(name: string) {
        name = _.escapeRegExp(name);
        return this.branchList.filter(branch => (new RegExp(name, 'gi').test(branch.branch_name)));
    }
    displayBranchFn(branchID: number) {
        if (branchID && this.branchList.length > 0) {
            let fitem = _.find(this.branchList, { 'branch_id': branchID });
            return fitem['branch_name'];
        }
        return '';
    }

    displayToGiveFn(toGiveType: any) {
        if (this.toGiveTypeList != undefined && this.toGiveTypeList.length > 0 && toGiveType) {
            return this.toGiveTypeList.indexOf(toGiveType) >= 0 ? toGiveType : '';
        }
        return '';
    }

    displayTaxTypeFn(taxType: any) {
        if (this.taxTypeList != undefined && this.taxTypeList.length > 0 && taxType) {
            return this.taxTypeList.indexOf(taxType) >= 0 ? taxType : '';
        }
        return '';
    }

    filterHvUser(name: string) {
        name = _.escapeRegExp(name);
        return this.hvUserList.filter(user => (new RegExp(name, 'gi').test(user.fullname)));
    }

    displayHvUserFn(userID: number) {
        if (this.hvUserList != undefined) {
            if (userID && this.hvUserList.length > 0) {
                if (typeof userID == 'string') {
                    userID = parseInt(userID);
                }
                let fitem = _.find(this.hvUserList, { 'userid': userID });
                return fitem && fitem['fullname'] ? fitem['fullname'] : '';
            }
        }
        return '';
    }

    onSelectPartyName(party_id) {
        // let that = this,
        //     mode = this._params['mode'],
        //     bill_type = this.purchaseInvoice['tabParams'],
        let that = this,
            params = {
                party_id
            };
        this.purchaseInvoiceService
            .getPurchaseReturnDetails(params)
            .then(function (res: any) {
                if (res.success) {
                    that.returnNoCtrl.setValue(that.purchasegriddata['return_id']);
                    that.returnList = res.data;
                }
            });
    }

    filterModel(name: string) {
        name = _.escapeRegExp(name);
        return this.ModelList.filter(item => (new RegExp(name, 'gi').test(item.model_id)
            || new RegExp(name, 'gi').test(item.name)));
    }

    displayModelFn(modelID: number) {
        if (modelID && this.ModelList.length > 0) {
            let fitem = _.find(this.ModelList, { 'model_id': modelID });
            this.purchasegriddata['model_name'] = fitem['name'];
            this.purchasegriddata['mrp'] = fitem['mrp'];
            this.purchasegriddata['brand_name'] = fitem['brand_name'];
            this.purchasegriddata['brand_model_name'] = fitem['brand_model_name'];
            this.purchasegriddata['family_name'] = fitem['family_name'];
            this.purchasegriddata['series_name'] = fitem['series_name'];
            this.purchasegriddata['performance_name'] = fitem['performance_name'];
            this.purchasegriddata['power_name'] = fitem['power_name'];
            this.purchasegriddata['battery_name'] = fitem['battery_name'];
            this.purchasegriddata['color_name'] = fitem['color_name'];
            this.purchasegriddata['tele_audiology'] = fitem['tele_audiology'];
            this.purchasegriddata['brand_id'] = fitem['brand_id'];
            this.purchasegriddata['brand_model_id'] = fitem['brand_model_id'];
            this.purchasegriddata['family_id'] = fitem['family_id'];
            this.purchasegriddata['series_id'] = fitem['series_id'];
            this.purchasegriddata['performance_id'] = fitem['performance_id'];
            this.purchasegriddata['power_id'] = fitem['power_id'];
            this.purchasegriddata['battery_id'] = fitem['battery_id'];
            this.purchasegriddata['color_id'] = fitem['color_id'];
            return fitem['name'];
        }
        return '';
    }

    filterReturnList(name: string) {
        name = _.escapeRegExp(name);
        return this.returnList.filter(item => (new RegExp(name, 'gi').test(item.dispName)));
    }

    displayReturnNoFn(returnID: number) {
        this.returnSerialList = [];
        if (returnID && this.returnList.length > 0) {
            let fitem = _.find(this.returnList, { 'return_id': returnID });
            this.createRetSerialList(fitem);
            this.purchasegriddata['return_no'] = fitem['dispName'];
            return fitem['dispName'];
        }
        this.purchasegriddata['return_no'] = '';
        return '';
    }

    createRetSerialList(retObj) {
        const splitDet = retObj.details.split('@');
        if (splitDet && splitDet.length > 0) {
            this.returnSerialList = splitDet.map(obj => {
                const det = obj.split(",");
                return {
                    return_det_id: det[0],
                    serial_no: det[1]
                }
            });

            this.returnSerialNoCtrl.setValue(this.purchasegriddata['return_det_id']);
        }
    }

    filterReturnSerialList(name: string) {
        name = _.escapeRegExp(name);
        return this.returnSerialList.filter(item => (new RegExp(name, 'gi').test(item.serial_no)));
    }

    displayReturnSerialFn(returnDetID: number) {
        if (returnDetID && this.returnSerialList.length > 0) {
            let fitem = _.find(this.returnSerialList, { 'return_det_id': returnDetID });
            this.purchasegriddata['return_serial_no'] = fitem['serial_no'];
            return fitem['serial_no'];
        }
        this.purchasegriddata['return_serial_no'] = '';
        return '';
    }

    onEnterKeyPressed(nextEl: string): void {
        if (_.isEmpty(document.getElementById(nextEl))) {
            nextEl = 'empid';
        }
        $('#' + nextEl).focus();
    }

    loadAutoNumber(): void {
        let that = this,
            data = {
                account_type: this.purchaseInvoice['tabParams'],
                date: moment(this.purchaseInvoice['date']).format('YYYY-MM-DD')
            };
        this.commonService
            .getAutoNumber(data)
            .then(function (res: any) {
                if (res['success']) {
                    that.purchaseInvoice['auto_no'] = res['auto_no'];
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: 'Oops, Something Went Wrong'
                    };
                    that.toasterService.pop(toast);
                }
            });
    }


    setPageData(): void {
        if (this._params != undefined) {
            let mode = this._params['mode'];
            this.purchaseInvoice = Object.assign({}, this._params);
            if (mode != 'Add') {
                this.getPurchaseInvoiceDetailList();
                this.purchaseInvoice['date'] = new Date(this._params['date']);//new Date();
                this.purchaseInvoice['hidden_party'] = this._params['party_name'];
                this.purchaseInvoice['hidden_type'] = this._params['type'];
            }
        }
    }

    getPurchaseInvoiceDetailList(): void {
        let that = this,
            mode = this._params['mode'],
            bill_type = this.purchaseInvoice['tabParams'],
            params = {
                start: `${this.page.offset}`,
                limit: `${this.page.limit}`,
                orderColumn: `${this.page.orderBy}`,
                orderBy: 'purchase_id',
                orderDir: `${this.page.orderDir}`,
                purchase_id: this.purchaseInvoice['purchase_id'],
                mode: this._params['mode']
            };
        this.isLoadMask = this.purchaseInvoiceService
            .getPurchaseInvoiceDetailList(params)
            .then(function (res: any) {
                if (res.success) {
                    that.page.count = res.totCnt;
                    // Process data to ensure tax_amount is populated for old entries
                    that.purchaseInvoiceDetails = res.data.map(item => {
                        // Use calculated_tax_amount from backend if available, otherwise calculate it
                        if (item.calculated_tax_amount !== undefined) {
                            item.tax_amount = parseFloat(item.calculated_tax_amount);
                        } else if (!item.tax_amount || item.tax_amount === 0) {
                            // Fallback calculation for very old entries
                            const taxAmount = (parseFloat(item.mrp_value || 0) * parseFloat(item.act_qty || 0) * parseFloat(item.tax || 0)) / 100;
                            item.tax_amount = parseFloat(taxAmount.toFixed(2));
                        }
                        return item;
                    });
                    that.calGrossTotal();
                }
            });
    }

    checkSrf(): void {
        let that = this,
            mode = this._params['mode'],
            bill_type = this.purchaseInvoice['tabParams'],
            params = {
                receipt_no: this.purchaseInvoice['receipt_no']
            };
        this.isLoadMask = this.purchaseInvoiceService
            .checkSrf(params)
            .then(function (res: any) {
                if (res.success) {
                    //that.page.count = res.totCnt;
                    that.purchaseInvoice['srf_no'] = res.srf_no;
                    swal('SRF Details', res.message);

                    //that.calGrantTotal('all');
                }
            });
    }




    onDeletePurchaseInvoiceEntry(row: any): void {
        let that = this,
            mode = this._params['mode'];


        if (mode == 'Add') {
            this.purchaseInvoiceDetails.splice(this.purchaseInvoiceDetails.indexOf(row), 1);
            //this.purchasegriddata = [];

            this.calGrossTotal();
            this.clearRoundoff();
        } else {
            let params = {
                stock_type: row.stock_type,
                model_id: row.model_id,
                model_name: row.model_name,
                act_qty: row.act_qty,
                mrp: row.mrp,
                purchase_id: row.purchase_id,
                bill_type: this.purchaseInvoice['tabParams'],
                serial_no: row['serial_no']
            };

            //  this.purchasegriddata = [];

            this.purchaseInvoiceService
                .deleteGridList(params)
                .then(function (res: any) {
                    that.isLoading = false;
                    if (res.success) {
                        that.purchaseInvoiceDetails.splice(that.purchaseInvoiceDetails.indexOf(row), 1);
                        swal('SUCCESS', res.message, 'success');
                        that.getPurchaseInvoiceDetailList();

                    } else {

                        swal('ERROR', res.message, 'error');
                    }
                });
        }
    }

    addPurchaseInvoice(): void {
        console.log(this.purchasegriddata, "check for month purpose ::::")
        let that = this,
            mode = this.purchaseInvoice['mode'],
            modelID = this.purchasegriddata['model_id'],
            modelName = this.purchasegriddata['model_name'],
            serialNo = this.purchasegriddata['serial_no'],
            stockType = this.purchasegriddata['stock_type'],
            returnSerialNo = this.purchasegriddata['return_serial_no'],
            returnDetID = this.purchasegriddata['return_det_id'];
        if (!_.isEmpty(_.toString(modelID))) {//} != undefined) {
            //IF preTestID FOUND, THAT ID IS ALREDAY AVAILABLE INSIDE TABLE
            let preTestID = _.find(this.purchaseInvoiceDetails, { 'model_id': modelID, 'serial_no': serialNo });

            if (preTestID) {
                swal('WARNING', 'Model : ' + modelName + ', Serial NO: ' + serialNo + ' Already Exists');
                return;
            }

            /*  let actQty = this.purchasegriddata['act_qty'];
              if (_.isEmpty(actQty)){ // 11 > 10
                  swal('WARNING', 'Enter Quantity ');
                  return;
              }*/


            //HA = this.purchase
            if (_.isEmpty(serialNo) && (stockType == 'HA Model')) { // 11 > 10
                swal('WARNING', 'Enter SERIAL NO ');
                return;
            }
            let MRP = this.purchasegriddata['mrp_value'];
            if (_.isEmpty(MRP)) { // 11 > 10
                swal('WARNING', 'Enter MRP ');
                return;
            }
            let TAX = this.purchasegriddata['tax'];
            if (_.isEmpty(TAX)) { // 11 > 10
                /* swal('WARNING', 'Enter TAX ');
                return; */
                this.purchasegriddata['tax'] = 0;
            }
            let DISCOUNT = this.purchasegriddata['discount'];
            if (_.isEmpty(DISCOUNT)) { // 11 > 10
                /* swal('WARNING', 'Enter Discount ');
                return; */
                this.purchasegriddata['discount'] = 0;

            }
            if (returnDetID && !_.isEmpty(returnDetID.toString())) {
                const preDetID = _.find(this.purchaseInvoiceDetails, { 'return_det_id': returnDetID });
                if (preDetID) {
                    swal('WARNING', returnSerialNo + ': Return Serial NO Already Exists');
                    return;
                }
            }

            let dataDet = {
                stock_type: stockType,
                model_id: modelID,
                model_name: modelName,
                serial_no: serialNo,
                purchase_return_id: that.purchaseInvoice['purchase_return_id'] || ''
            }
            this.purchaseInvoiceService
                .getModelDetails(dataDet)
                .then(function (res: any) {

                    if (res.success) {
                        swal('ERROR', res.message, 'error');
                        return;
                    } else {
                        if (mode == 'Add') {
                            let testDet = Object.assign({}, that.purchasegriddata);
                            that.purchaseInvoiceDetails.push(testDet);
                            console.log(that.purchaseInvoiceDetails, "check for row purpose ::::")
                            that.purchasegriddata['return_no'] = '';
                            that.purchasegriddata['return_serial_no'] = '';
                            that.purchasegriddata['return_det_id'] = null;
                            if (that.purchasegriddata['check'] == true) {
                                if (that.purchasegriddata['stock_type'] == 'HA Model') {
                                    that.purchasegriddata['serial_no'] == "";
                                    $('#' + 'stock_serial_no').val("");
                                    $('#' + 'stock_serial_no').focus();
                                } else {
                                    that.purchasegriddata = [];
                                    $('#' + 'stock_type').focus();
                                }
                            } else {
                                that.purchasegriddata = [];
                                $('#' + 'stock_type').focus();
                            }

                            //   this.purchasegriddata['amount'] = 0;
                            that.page.count = that.purchaseInvoiceDetails.length;
                            that.calGrossTotal();
                            that.clearRoundoff();
                            //this.serialNoList = [];
                        } 
                        else if (mode == 'Edit') {
                            let params = {
                                start: `${that.page.offset}`,
                                limit: `${that.page.limit}`,
                                brand_id: that.purchasegriddata['brand_id'],
                                brand_model_id: that.purchasegriddata['brand_model_id'],
                                family_id: that.purchasegriddata['family_id'],
                                series_id: that.purchasegriddata['series_id'],
                                performance_id: that.purchasegriddata['performance_id'],
                                power_id: that.purchasegriddata['power_id'],
                                battery_id: that.purchasegriddata['battery_id'],
                                color_id: that.purchasegriddata['color_id'],
                                model_id: that.purchasegriddata['model_id'],
                                month: that.purchasegriddata['month'],
                                year: that.purchasegriddata['year'],
                                model_name: that.purchasegriddata['model_name'],
                                mrp: that.purchasegriddata['mrp'],
                                mrp_value: that.purchasegriddata['mrp_value'],
                                tax: that.purchasegriddata['tax'],
                                tax_amount: that.purchasegriddata['tax_amount'],
                                tax_type: that.purchasegriddata['tax_type'],
                                sgst_rate: that.purchasegriddata['sgst_rate'],
                                cgst_rate: that.purchasegriddata['cgst_rate'],
                                igst_rate: that.purchasegriddata['igst_rate'],
                                discount: that.purchasegriddata['discount'],
                                total_amount: that.purchasegriddata['total_amount'],
                                act_qty: that.purchasegriddata['act_qty'],
                                purchase_id: that.purchaseInvoice['purchase_id'],
                                party_id: that.purchaseInvoice['party_id'],
                                stock_type: that.purchasegriddata['stock_type'],
                                serial_no: that.purchasegriddata['serial_no']
                            },
                                testDet = Object.assign({}, that.purchasegriddata);

                            that.purchaseInvoiceService
                                .addPurchaseInvoice(params)
                                .then(function (res: any) {
                                    that.isLoading = false;

                                    if (res.success) {
                                        swal('SUCCESS', res.message, 'success');
                                        that.page.count = res.totCnt;
                                        that.page.count = that.purchaseInvoiceDetails.length;
                                        that.purchaseInvoiceDetails.push(testDet);
                                        console.log(that.purchaseInvoiceDetails, "check for row Edit purpose ::::")
                                        that.purchasegriddata['return_no'] = '';
                                        that.purchasegriddata['return_serial_no'] = '';
                                        that.purchasegriddata['return_det_id'] = null;

                                        if (that.purchasegriddata['check'] == true) {
                                            if (that.purchasegriddata['stock_type'] == 'HA Model') {
                                                that.purchasegriddata['serial_no'] == "";
                                                $('#' + 'stock_serial_no').val("");
                                                $('#' + 'stock_serial_no').focus();
                                            } else {
                                                that.purchasegriddata = [];
                                                that.purchasegriddata['amount'] = 0;
                                                $('#' + 'stock_type').focus();
                                            }
                                        } else {
                                            that.purchasegriddata = [];
                                            that.purchasegriddata['amount'] = 0;
                                            $('#' + 'stock_type').focus();
                                        }
                                        //that.purchasegriddata = [];
                                        //that.calAmount();


                                        that.getPurchaseInvoiceDetailList();
                                    } else {
                                        swal('ERROR', res.message, 'error');
                                    }
                                })
                        }

                    }
                    // return;
                })



        }
    }

    calModel() {
        if (this.purchasegriddata.stock_type === 'HA Model') {
            this.purchasegriddata = {};
            this.purchasegriddata.stock_type = 'HA Model';
        } else if (this.purchasegriddata.stock_type === 'Spare') {
            this.purchasegriddata = {};
            this.purchasegriddata.stock_type = 'Spare';
        }

        // Initialize tax fields with defaults
        this.purchasegriddata.tax_type = 'SGST and CGST';
        this.purchasegriddata.tax = 0;
        this.purchasegriddata.tax_amount = 0;
        this.purchasegriddata.sgst_rate = 0;
        this.purchasegriddata.cgst_rate = 0;
        this.purchasegriddata.igst_rate = 0;

        let qty = 1;
        //this.purchasegriddata = [];
        this.purchasegriddata.act_qty = qty;
        //this.purchasegriddata['serial_no'] = "qty";
        // if(this.purchasegriddata['stock_type']=='Spare'){
            this.loadStockModelList();
        // }
        // this.onSelectedType(this.purchasegriddata['stock_type']);
    }
    calAmount() {
        let qty = this.purchasegriddata.act_qty,
            val = this.purchasegriddata.mrp_value,
            tax = this.purchasegriddata.tax || 0,
            dis = this.purchasegriddata.discount,
            amt = 0,
            tax_amt = 0,
            tot_amt = 0,
            dis_amt = 0;

        if (!_.isEmpty(_.toString(val))) {
            amt = (qty * val);
        }

        // Calculate tax amount
        if (!_.isEmpty(_.toString(tax)) && tax > 0) {
            tax_amt = (amt * parseFloat(tax)) / 100;
            amt = amt + tax_amt;
        }

        // Store the calculated tax amount
        this.purchasegriddata.tax_amount = parseFloat(tax_amt.toFixed(2));

        tot_amt = parseFloat(amt.toFixed(2));

        if (!_.isEmpty(_.toString(dis))) {
            tot_amt = (tot_amt) - (dis);
        }
        dis_amt = parseFloat(tot_amt.toFixed(2));

        this.purchasegriddata.total_amount = dis_amt;
    }

    onTaxTypeChange() {
        // Reset tax values when tax type changes
        this.purchasegriddata.sgst_rate = 0;
        this.purchasegriddata.cgst_rate = 0;
        this.purchasegriddata.igst_rate = 0;
        this.purchasegriddata.tax = 0;
        this.purchasegriddata.tax_amount = 0;

        // Recalculate total tax
        this.calculateTotalTax();
        this.calAmount();
    }

    onIndividualTaxChange() {
        // Auto-calculate total tax when individual tax rates change
        this.calculateTotalTax();
        this.calAmount();
    }

    calculateTotalTax() {
        const taxType = this.purchasegriddata.tax_type || 'SGST and CGST';
        let totalTax = 0;

        if (taxType === 'IGST') {
            totalTax = parseFloat(this.purchasegriddata.igst_rate) || 0;
            // Ensure other rates are 0 for IGST
            this.purchasegriddata.sgst_rate = 0;
            this.purchasegriddata.cgst_rate = 0;
        } else { // SGST and CGST
            const sgstRate = parseFloat(this.purchasegriddata.sgst_rate) || 0;
            const cgstRate = parseFloat(this.purchasegriddata.cgst_rate) || 0;
            totalTax = sgstRate + cgstRate;
            // Ensure IGST is 0 for SGST+CGST
            this.purchasegriddata.igst_rate = 0;
        }

        this.purchasegriddata.tax = totalTax;
    }
    calGrossTotal() {
        let gross_total = 0;


        for (let i = 0; i < this.purchaseInvoiceDetails.length; i++) {
            let total_amount = this.purchaseInvoiceDetails[i].total_amount;
            gross_total += Number(total_amount);


        }
        this.purchaseInvoice['gross_total'] = gross_total;
        //this.purchaseInvoicepurchaseInvoice['free_item'] = free;

        this.calGrantTotal('all');
    }

    calGrantTotal(from_field) {

        let gross_total = this.purchaseInvoice['gross_total'],
            dis_per = this.purchaseInvoice['discount_percentage'],
            discount_amount = this.purchaseInvoice['discount_amount'],
            grant_total = 0;

        if (_.isEmpty(_.toString(gross_total))) {
            gross_total = 0;
        }
        if (!_.isEmpty(_.toString(dis_per))) {
            if (dis_per >= 0 && from_field == 'dis_per') {
                this.purchaseInvoice['discount_amount'] = 0;
                discount_amount = (gross_total * dis_per) / 100;

            }
        } else {
            dis_per = 0;
            discount_amount = 0;
        }
        if (!_.isEmpty(_.toString(discount_amount)) && discount_amount != 0) {
            if (from_field == 'dis_amt')
                this.purchaseInvoice['discount_percentage'] = 0;//(parseFloat(discount_amount) / parseFloat(gross_total)) * 100;
            dis_per = (discount_amount / gross_total) * 100;
            dis_per = (dis_per.toFixed(2)) / 1;

        } else {
            discount_amount = 0;
            dis_per = 0;
        }

        grant_total = (parseFloat(gross_total) - parseFloat(discount_amount));
        this.purchaseInvoice['discount_percentage'] = dis_per;
        this.purchaseInvoice['discount_amount'] = discount_amount;
        this.purchaseInvoice['amount'] = grant_total;

        let round = this.purchaseInvoice['round_off'] || 0,
            value = grant_total + parseFloat(round);
        this.purchaseInvoice['amount'] = value;

    }

    calRoundoff() {

        let grant_total = this.purchaseInvoice['amount'],
            round = this.purchaseInvoice['round_off'],
            value = 0;

        if (!_.isEmpty(_.toString(grant_total))) {
            value = (parseFloat(grant_total) - parseFloat(round));
        }

        this.purchaseInvoice['amount'] = value;
        this.calGrossTotal();
    }

    clearRoundoff() {
        this.purchaseInvoice['round_off'] = 0;
        this.calGrossTotal();
    }

    bsModalRef: BsModalRef;
    onSavePurchaseInvoice(): void {
        let that = this,
            mode = this.purchaseInvoice['mode'],
            advance = this.purchaseInvoice['advances'],
            initial_amount = this.purchaseInvoice['initial_amount'],
            purchaseInvoiceentry = this.purchaseInvoiceDetails.length,
            qty = 0,
            amt = 0;

        if (purchaseInvoiceentry == 0) {
            swal('WARNING', 'No Data Found, <br> Please Add Model Details');
            return;
        }
        for (let i = 0; i < purchaseInvoiceentry; i++) {
            amt += parseFloat(this.purchaseInvoiceDetails[i].total_amount);
        }
        for (let i = 0; i < purchaseInvoiceentry; i++) {
            qty += parseFloat(this.purchaseInvoiceDetails[i].act_qty);
        }
        let purchaseInvoiceDate = moment(this.purchaseInvoice['date']).format('YYYY-MM-DD'),
            data = {
                purchase_id: this.purchaseInvoice['purchase_id'],
                auto_no: this.purchaseInvoice['auto_no'],
                receipt_no: this.purchaseInvoice['receipt_no'],
                srf_no: this.purchaseInvoice['srf_no'],
                purchase_type: this.purchaseInvoice['purchase_type'],
                date: purchaseInvoiceDate,
                party_id: this.purchaseInvoice['party_id'],
                to_give_type: this.purchaseInvoice['to_give_type'],
                branch_id: this.purchaseInvoice['branch_id'],
                hv_user_id: this.purchaseInvoice['hv_user_id'],
                type: this.purchaseInvoice['stock_type'],
                purchaseInvoiceDetails: JSON.stringify(this.purchaseInvoiceDetails),
                grand_total: this.purchaseInvoice['amount'],
                gross_total: this.purchaseInvoice['gross_total'],
                discount_percentage: this.purchaseInvoice['discount_percentage'],
                discount_amount: this.purchaseInvoice['discount_amount'],
                round_off: this.purchaseInvoice['round_off'],
                description: this.purchaseInvoice['description'],
                mode: this.purchaseInvoice['mode'],
                page_from: this.purchaseInvoice['tabParams'],
                tot_qty: qty,
                amount: amt,
                purchase_return_id: this.purchaseInvoice['purchase_return_id'] || ''
            };


        this.calGrossTotal();
        data['grand_total'] = this.purchaseInvoice['amount'];
        data['gross_total'] = this.purchaseInvoice['gross_total'];
        data['discount_percentage'] = this.purchaseInvoice['discount_percentage'];
        data['discount_amount'] = this.purchaseInvoice['discount_amount'];

        that.isLoading = true;
        this.purchaseInvoiceService
            .addUpdatePurchaseInvoiceEntry(data)
            .then(function (res: any) {
                that.isLoading = false;
                if (res.success) {
                    that.purchaseInvoice = [];
                    that.purchaseInvoiceDetails = [];
                    swal('SUCCESS', res.message, 'success');
                    that.subscribeService.subScribeDeleteActiveTab();
                    that.subscribeService.subReloadSalesBillentryListGrid();
                } else {
                    swal('ERROR', res.message, 'error');
                }
            })
            .catch(function (error: any) {
                that.isLoading = false;
                let res = JSON.parse(error._body);
                swal('ERROR', res.message, 'error');
                //console.log(error);
            });
    }

}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/purchaseInvoice/addEditPurchaseInvoice.component.ts